import React from 'react';
import { siteData } from '../data/mock';
import { Quote } from 'lucide-react';

const AuthoritySection = () => {
  return (
    <section id="authority" className="section">
      <div className="container">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Image */}
            <div className="relative">
              <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src={siteData.authority.image}
                  alt="AtivaJá"
                  className="w-full h-auto object-cover"
                />
                {/* Gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 to-transparent" />
              </div>
              {/* Decorative elements */}
              <div className="absolute -top-4 -right-4 w-24 h-24 bg-blue-100 rounded-full opacity-60 blur-2xl" />
              <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-blue-200 rounded-full opacity-40 blur-3xl" />
            </div>

            {/* Content */}
            <div className="relative">
              <Quote size={48} className="text-blue-100 mb-6" />
              <div className="space-y-4">
                {siteData.authority.text.map((line, index) => (
                  <p
                    key={index}
                    className={`${
                      index < 2
                        ? 'text-2xl font-semibold text-slate-800'
                        : 'text-lg text-slate-600'
                    }`}
                  >
                    {line}
                  </p>
                ))}
              </div>

              {/* Visual accent */}
              <div className="mt-8 flex items-center gap-3">
                <div className="h-1 w-12 bg-blue-600 rounded-full" />
                <span className="text-sm font-medium text-blue-600">AtivaJá</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AuthoritySection;
